import MenuIcon from "@mui/icons-material/Menu";

import { useTranslationsContext } from "../../../contexts/TranslationsContext";

function StepFour(): JSX.Element {
  const { translation } = useTranslationsContext();

  return (
    <div className="ath-step-content">
      <span className="ath-step-number">4</span>
      <div className="ath-step-icon">
        <MenuIcon />
      </div>
      <p className="ath-step-text">
        {translation.INSTALL_APP_STEP_4.defaultMessage}
      </p>
    </div>
  );
}

export default StepFour;
